<script>
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import Loader from "@/components/widgets/loader";
import { swal } from "../../../helpers/handle_error";
import exportToExcel from "../../../helpers/export_to_excel";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default {
  components: { AlertError, Loader },
  data() {
    return {
      //Page errors.
      errors: [],
      showLoader: true,
      showAlert: false,

      volunteer: "",

      items: [],

      // datatable
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalItemsFiltered: 0,
      pageOptions: [
        10,
        25,
        50,
        100,
        { value: Number.MAX_SAFE_INTEGER, text: "عرض الكل" },
      ],
      filter: "",
      filterOn: [],
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        {
          // A virtual column that doesn't exist in items
          label: "التسلسل",
          key: "index",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "الاسم الرباعي",
          key: "full_name",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "full_name",
          searchable: true,
        },
        {
          label: "تاريخ التقديم",
          key: "created_at",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "created_at",
          searchable: true,
        },
        {
          label: "الاجراءات",
          key: "settings",
          class: "col-setting-application",
          sortable: true,
          visible: this.$store.getters["auth/getUser"].hasAnyPermission([
            "show_details_volunteer_application",
            "delete_volunteer_application",
          ]),
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("application", ["getVolunteers"]),
    start() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    end() {
      return Math.min(this.currentPage * this.perPage, this.totalItems);
    },
  },
  methods: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    ...mapActions("application", ["getAll", "delete"]),
    search() {
      if (this.currentPage == 1) this.fetchAll(true);
      else this.currentPage = 1;
    },
    fetchAll(is_search) {
      if (!is_search) {
        this.showLoader = true;
      }

      var query = new URLSearchParams({
        draw: this.currentPage,
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      });
      query.append("_datatable", "1");
      let columns = this.fields.filter((f) => !f.isVirtual);
      columns.forEach((el, index) => {
        query.append("columns[" + index + "][data]", el.name);
        query.append("columns[" + index + "][name]", el.name);
        query.append("columns[" + index + "][orderable]", el.sortable);
        query.append("columns[" + index + "][searchable]", el.searchable);
        query.append("columns[" + index + "][search][value]", "");
        query.append("columns[" + index + "][search][regex]", "false");
      });
      query.append("search[value]", this.filter);
      query.append("search[regex]", "false");

      query.append("order[0][column]", 1);
      query.append("order[0][dir]", "desc");

      this.getAll(query)
        .then((response) => {
          this.totalItemsFiltered = response.data.recordsFiltered;
          this.totalItems = response.data.recordsTotal;

          this.items = this.getVolunteers;
          this.showLoader = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.showLoader = false;
        });
    },
    async deleteItem(id) {
      if (await swal.confirm()) {
        swal.loading();
        this.delete(id)
          .then((response) => {
            this.fetchAll();
            swal.success(response.data.message);
          })
          .catch((error) => {
            this.handleError(error);
            swal.close();
          });
      }
    },
    exportTable() {
      exportToExcel(this.visibleFields(), this.items, "أستمارة التطوع");
    },
    //saveAsPDF
    saveAsPDF() {
      const element = this.$refs.printcontent;

      html2canvas(element, { scale: 3 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "cm", "a4");
        pdf.addImage(imgData, "PNG", 0, 0, 21, 29.7);
        pdf.save("document.pdf");
      });
    },

    // save Interview Form
    async saveAsInterviewForm() {
      await this.$nextTick(); // يتأكد أن DOM محدث بعد أي تغييرات

      const elements = this.$refs.printcontent2.querySelectorAll(".print-one-page");
      const pdf = new jsPDF("p", "cm", "a4");

      for (let i = 0; i < elements.length; i++) {
        const canvas = await html2canvas(elements[i], { scale: 3 });
        const imgData = canvas.toDataURL("image/jpeg", 0.9);
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, 0, 21, 29.7);
      }

      const fileName = this.volunteer.full_name + ".pdf";
      pdf.save(fileName);
    },

    // showPDF
    showPDF(id) {
      this.volunteer = this.getVolunteers.find((s) => s.id == id);
      alert(this.volunteer);
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchAll();
      },
    },
    perPage: {
      handler: function () {
        this.fetchAll();
      },
    },
  },
  created() {
    this.fetchAll();
  },
};
</script>

<template>
  <div>
    <!-- start modal-interview-form -->
    <b-modal
      id="modal-interview-form"
      v-if="typeof volunteer == 'object'"
      centered
      title-class="font-18"
      hide-footer
    >
      <template #modal-title>
        <b-button @click="saveAsInterviewForm" class="btn-sm" variant="info"
          >تحميل الاستمارة بصيغة (pdf)</b-button
        >
      </template>
      <div class="scholar-ships-print-interview-form" ref="printcontent2">
        <BRow class="print-one-page">
          <div class="border-one-page">
            <BCol cols="12 text-center mb-5">
              <p class="font-size-15">
                استمارة مقابلات منح اجازات التأسيس للفرق والمنظمات
              </p>
            </BCol>
            <BCol cols="12">
              <BRow class="align-items-center mb-1">
                <div class="col">
                  <p>
                    التاريخ :&nbsp;&nbsp;&nbsp; / &nbsp;&nbsp;&nbsp;
                    /&nbsp;&nbsp;&nbsp;&nbsp;202
                  </p>
                </div>
                <div class="col">
                  <p>رقم الاستمارة :</p>
                </div>
                <div class="col text-end">
                  <img src="@/assets/images/user.jpg" class="photo" alt="" />
                </div>
              </BRow>
              <BTableSimple class="form_table">
                <BThead>
                  <BTr>
                    <BTh colspan="2" width="120px">الاسم الرباعي و اللقب:</BTh>
                    <BTh colspan="2"> {{ volunteer.full_name }}</BTh>
                    <BTh>رقم الهاتف:</BTh>
                    <BTh colspan="2"> {{ volunteer.phone }}</BTh>
                  </BTr>
                </BThead>
                <BTbody>
                  <BTr>
                    <BTd>المحافظة:</BTd>
                    <BTd colspan="2">{{ volunteer.address.city.title }}</BTd>
                    <BTd>القضاء:</BTd>
                    <BTd>{{ volunteer.address.district }}</BTd>
                    <BTd>فصيلة الدم:</BTd>
                    <BTd></BTd>
                  </BTr>
                  <BTr>
                    <BTd colspan="2">المنظمة / الفريق:</BTd>
                    <BTd colspan="6"></BTd>
                  </BTr>
                  <BTr>
                    <BTd>التقييم الامني:</BTd>
                    <BTd colspan="2">20-0</BTd>
                    <BTd>40-20</BTd>
                    <BTd>60-40</BTd>
                    <BTd>60-80</BTd>
                    <BTd>80-100</BTd>
                  </BTr>
                  <BTr class="hight-row">
                    <BTd>الملاحظة الامنية:</BTd>
                    <BTd colspan="6"></BTd>
                  </BTr>
                  <BTr>
                    <BTd colspan="2">مجال نشاط المتطوع:</BTd>
                    <BTd>حشدي</BTd>
                    <BTd>اسلامي</BTd>
                    <BTd>علماني</BTd>
                    <BTd>تخصصي</BTd>
                    <BTd>اعلام</BTd>
                  </BTr>
                  <BTr>
                    <BTd>القرار:</BTd>
                    <BTd colspan="2">يمنح هوية</BTd>
                    <BTd colspan="2">لايمنح هوية</BTd>
                    <BTd colspan="2">تريث</BTd>
                  </BTr>
                  <BTr>
                    <BTd>الصفة:</BTd>
                    <BTd colspan="6"></BTd>
                  </BTr>
                </BTbody>
              </BTableSimple>
              <BRow class="align-items-center text-center mb-1 mt-5">
                <div class="col">
                  <p>العضو الاول</p>
                </div>
                <div class="col">
                  <p>العضو الثاني</p>
                </div>
                <div class="col">
                  <p>رئيس اللجنة</p>
                </div>
              </BRow>
              <BRow>
                <p class="text-center mt-5 mb-5">مدير المركز</p>
              </BRow>
            </BCol>
          </div>
        </BRow>
        <BRow class="print-one-page">
          <div class="border-one-page">
            <BCol>
              <BRow class="text-center mb-4">
                <BCol cols="12">
                  <p class="font-size-15">المهارات والاعمال التطوعية</p>
                </BCol>
              </BRow>
              <BTableSimple class="form_table skills-work">
                <BTbody>
                  <BTr>
                    <BTh class="text-center" colspan="7"
                      >ماهي المهارات والمواهب والخبرات التي تملكها ؟
                    </BTh>
                  </BTr>
                  <BTr>
                    <BTh class="text-center" colspan="7">{{
                      volunteer.question.question_1_skills
                    }}</BTh>
                  </BTr>
                  <BTr>
                    <BTh class="text-center" colspan="7"
                      >اذا كان لديك مساهمات بدعم الحشد سابقا سواء كانت مساهمات اعلامية او
                      لوجستية او طبية او اي شكل من اشكال الدعم اذكرها , وتكلم عن تجربتك
                      بدعم الحشد
                    </BTh>
                  </BTr>

                  <BTr>
                    <BTh class="text-center" colspan="7"
                      >{{ volunteer.question.question_2_contributions }}
                    </BTh>
                  </BTr>
                  <BTr>
                    <BTh class="text-center" colspan="7"
                      >تفاصيل عن تاريخه في العمل التطوعي
                    </BTh>
                  </BTr>
                  <BTr>
                    <BTh class="text-center" colspan="7">{{
                      volunteer.question.question_5_experience
                    }}</BTh>
                  </BTr>
                  <BTr>
                    <BTh class="text-center" colspan="7"
                      >تفاصيل عن الخدمات التطوعية التي يريد تقديمها للمجتمع والمذكورة
                      بالاستمارة الالكترونية
                    </BTh>
                  </BTr>
                  <BTr>
                    <BTh class="text-center" colspan="7"
                      >{{ volunteer.question.question_6_services }}
                    </BTh>
                  </BTr>
                </BTbody>
              </BTableSimple>
            </BCol>
          </div>
        </BRow>
        <BRow class="print-one-page">
          <div class="border-one-page">
            <BCol>
              <BRow class="text-center mb-4">
                <BCol cols="12">
                  <p class="font-size-15">التقرير الامني</p>
                </BCol>
              </BRow>
              <BRow>
                <div class="media">
                  <label> الاسم الرباعي : </label>
                  <p class="mx-1">{{ volunteer.full_name }}</p>
                </div>
                <div class="media">
                  <label> المنظمة : </label>
                  <p class="mx-1"></p>
                </div>
              </BRow>
              <BTableSimple class="form_table">
                <BThead> </BThead>
                <BTbody>
                  <BTr>
                    <BTh width="120px">الحركات المنحرفة:</BTh>
                    <BTd width="90px">20-0</BTd>
                    <BTd>40-20</BTd>
                    <BTd>60-40</BTd>
                    <BTd width="90px">60-80</BTd>
                    <BTd width="100px">80-100</BTd>
                  </BTr>
                  <BTr>
                    <BTh>الحشد الشعبي:</BTh>
                    <BTd>20-0</BTd>
                    <BTd>40-20</BTd>
                    <BTd>60-40</BTd>
                    <BTd>60-80</BTd>
                    <BTd>80-100</BTd>
                  </BTr>
                  <BTr>
                    <BTh>تشرين:</BTh>
                    <BTd>20-0</BTd>
                    <BTd>40-20</BTd>
                    <BTd>60-40</BTd>
                    <BTd>60-80</BTd>
                    <BTd>80-100</BTd>
                  </BTr>
                  <BTr>
                    <BTh>حزب البعث:</BTh>
                    <BTd>20-0</BTd>
                    <BTd>40-20</BTd>
                    <BTd>60-40</BTd>
                    <BTd>60-80</BTd>
                    <BTd>80-100</BTd>
                  </BTr>
                  <BTr>
                    <BTh>الاحتلال الامريكي:</BTh>
                    <BTd>20-0</BTd>
                    <BTd>40-20</BTd>
                    <BTd>60-40</BTd>
                    <BTd>60-80</BTd>
                    <BTd>80-100</BTd>
                  </BTr>
                  <BTr>
                    <BTh>الحكم الاسلامي:</BTh>
                    <BTd>20-0</BTd>
                    <BTd>40-20</BTd>
                    <BTd>60-40</BTd>
                    <BTd>60-80</BTd>
                    <BTd>80-100</BTd>
                  </BTr>
                  <BTr>
                    <BTh>المظهر الخارجي / الحجاب:</BTh>
                    <BTd>20-0</BTd>
                    <BTd>40-20</BTd>
                    <BTd>60-40</BTd>
                    <BTd>60-80</BTd>
                    <BTd>80-100</BTd>
                  </BTr>
                  <BTr>
                    <BTh>المنظمات المدعومة امريكيا:</BTh>
                    <BTd colspan="2">لديه تشخيص دقيق لها</BTd>
                    <BTd colspan="2">ليس لديه مشكلة بالعمل معها</BTd>
                    <BTd colspan="2">لا يملك وعي كافي حولها</BTd>
                  </BTr>
                  <BTr>
                    <BTd rowspan="3"> اسماء اقرباءه او اصدقائه في الحشد مع الصلة:</BTd>
                    <BTd>الاسم الثلاثي:</BTd>
                    <BTd colspan="2"> </BTd>
                    <BTd>صلة القرابة:</BTd>
                    <BTd> </BTd>
                  </BTr>
                  <BTr>
                    <BTd>الاسم الثلاثي:</BTd>
                    <BTd colspan="2"> </BTd>
                    <BTd>صلة القرابة:</BTd>
                    <BTd> </BTd>
                  </BTr>
                  <BTr>
                    <BTd>الاسم الثلاثي:</BTd>
                    <BTd colspan="2"> </BTd>
                    <BTd>صلة القرابة:</BTd>
                    <BTd> </BTd>
                  </BTr>
                  <BTr>
                    <BTd rowspan="3"> اسماء اقرباءه الشهداء:</BTd>
                    <BTd>الاسم الثلاثي:</BTd>
                    <BTd colspan="2"> </BTd>
                    <BTd>صلة القرابة:</BTd>
                    <BTd> </BTd>
                  </BTr>
                  <BTr>
                    <BTd>الاسم الثلاثي:</BTd>
                    <BTd colspan="2"> </BTd>
                    <BTd>صلة القرابة:</BTd>
                    <BTd> </BTd>
                  </BTr>
                  <BTr>
                    <BTd>الاسم الثلاثي:</BTd>
                    <BTd colspan="2"> </BTd>
                    <BTd>صلة القرابة:</BTd>
                    <BTd> </BTd>
                  </BTr>
                </BTbody>
              </BTableSimple>
              <BRow class="align-items-center text-center mb-1 mt-5">
                <div class="col">
                  <p>العضو الاول</p>
                </div>
                <div class="col">
                  <p>العضو الثاني</p>
                </div>
                <div class="col">
                  <p>رئيس اللجنة</p>
                </div>
              </BRow>
              <BRow>
                <p class="text-center mt-5 mb-5">مدير المركز</p>
              </BRow>
            </BCol>
          </div>
        </BRow>
      </div>
    </b-modal>
    <!-- end modal-interview-form -->
    <!-- -------------------------- -->
    <!-- start modal-pdf -->
    <b-modal
      id="modal-pdf"
      v-if="typeof volunteer == 'object'"
      centered
      title-class="font-18"
      hide-footer
    >
      <template #modal-title>
        <b-button @click="saveAsPDF" class="btn-sm" variant="info"
          >تحميل الاستمارة بصيغة (pdf)</b-button
        >
      </template>
      <div class="scholar-ships-print" ref="printcontent">
        <div class="center">
          <div class="text-center">
            <img src="@/assets/images/logo.png" class="logo" alt="" />
            <p class="mb-0 font-size-16">المديرية العامة للعلاقات والخدمات الاجتماعية</p>
            <p class="mb-3 font-size-12">استمارة التطوع</p>
          </div>
          <h5 style="width: 151px">المعلومات الاساسية:</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-6">
              <p><strong class="mx-1">الاسم :</strong> {{ volunteer.full_name }}</p>
              <p><strong class="mx-1">الجنس :</strong>{{ volunteer.gender.title }}</p>
              <p>
                <strong class="mx-1">تاريخ التولد :</strong>{{ volunteer.birth_date }}
              </p>
              <p><strong class="mx-1"> العمل :</strong>{{ volunteer.job.title }}</p>
              <p>
                <strong class="mx-1">اللغات التي تتحدثها :</strong
                >{{ volunteer.langs.map((l) => l.title).join(" , ") }}
              </p>
            </div>
            <div class="col-md-6">
              <p><strong class="mx-1">اللقب :</strong>{{ volunteer.family_name }}</p>
              <p>
                <strong class="mx-1">الحالة الاجتماعية :</strong
                >{{ volunteer.marital_status.title }}
              </p>
              <p><strong class="mx-1">رقم الهاتف :</strong>{{ volunteer.phone }}</p>
              <p>
                <strong class="mx-1">التحصيل الدراسي :</strong
                >{{ volunteer.certificateInfo.certificate.title }}
              </p>
            </div>
          </div>

          <h5 style="width: 100px">عنوان السكن :</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-6">
              <p>
                <strong class="mx-1">المحافظة :</strong>{{ volunteer.address.city.title }}
              </p>
              <p><strong class="mx-1">القضاء:</strong>{{ volunteer.address.district }}</p>
            </div>
            <div class="col-md-6">
              <p>
                <strong class="mx-1">مكان الاقامة الحالي :</strong
                >{{ volunteer.address.currrent }}
              </p>
              <p>
                <strong class="mx-1">اقرب نقطة دالة :</strong
                >{{ volunteer.address.nearest_point }}
              </p>
            </div>
          </div>

          <h5 style="width: 197px">المهارات والاعمال التطوعية :</h5>
          <hr class="title-line" />
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="" />
                  <label>ما هي المهارات والمواهب والخبرات التي تملكها ؟ </label>
                </div>
                <p>{{ volunteer.question.question_1_skills }}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="" />
                  <label
                    >اذا كان لديك مساهمات بدعم الحشد سابقاً سواء كانت مساهمات اعلامية او
                    لوجستية او طبية او اي شكل من اشكال الدعم اذكرها , وتكلم عن تجربتك بدعم
                    الحشد
                  </label>
                </div>
                <p>{{ volunteer.question.question_2_contributions }}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="" />
                  <label
                    >هل لديك أقارب أو أصدقاء في الحشد الشعبي ؟ ( اذكر اسماءهم و ارقام
                    هواتفهم واماكن عملهم ان وجدت )
                  </label>
                </div>
                <p>{{ volunteer.question.question_3_friends }}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="" />
                  <label
                    >كيف حصلت على رابط الاستمارة ؟ ( اذكر اسم الصديق او المنصة الاعلامية
                    التي حصلت من خلالها على الرابط )
                  </label>
                </div>
                <p>{{ volunteer.question.question_4_link }}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="" />
                  <label
                    >تكلم عن تجربتك في العمل التطوعي ( اذكر اسم فريق العمل التطوعي او
                    المنظمة التي عملت فيها او التجربة التطوعية الفردية ان وجدت )</label
                  >
                </div>
                <p>{{ volunteer.question.question_5_experience }}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="" />
                  <label
                    >ما هي الخدمات التطوعية التي تحب تقديمها للمجتمع ؟ (مثلا: عن طريق
                    الاعلام , الفن , او عن طريق المهن الحرفية او التدريب او اي خدمة تستطيع
                    ان تبدع في تقديمها)</label
                  >
                </div>
                <p>{{ volunteer.question.question_6_services }}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="" />
                  <label>كم ساعة او يوم تستطيع تقديمها لخدمة الناس بشكل تطوعي ؟ </label>
                </div>
                <p>{{ volunteer.question.question_7_hours_days }}</p>
              </div>
              <div class="question-content">
                <div class="quest">
                  <img src="@/assets/images/users/bluequestion.png" alt="" />
                  <label>اذكر اي تفاصيل تود اضافتها : </label>
                </div>
                <p>{{ volunteer.question.details }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- end modal-pdf -->

    <!-- ------------------------- -->
    <Loader :loading="showLoader">
      <div class="row mt-3">
        <div class="col-12">
          <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

          <!-- Header Table -->
          <div class="row mt-1">
            <!-- table_length -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  عرض&nbsp;:&nbsp;
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  &nbsp;مدخلات
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  بحث&nbsp;:&nbsp;
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="بحث..."
                    @input="search"
                    class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
                <b-button class="btn-sm mx-2" variant="primary" @click="exportTable"
                  >Excel</b-button
                >
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              show-empty
              hover
              :items="items"
              :striped="true"
              :fields="visibleFields()"
              responsive="md"
              :current-page="currentPage"
              :per-page="0"
            >
              <!-- A virtual column -->
              <template #cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * perPage }}
              </template>

              <!-- A custom formatted column Sutting -->
              <template v-slot:cell(settings)="data">
                <div class="button-items">
                  <router-link
                    v-can="'show_details_volunteer_application'"
                    :to="{ name: 'application.details', params: { id: data.item.id } }"
                  >
                    <b-button class="btn-sm" variant="info">التفاصيل</b-button>
                  </router-link>
                  <b-button
                    @click="showPDF(data.item.id)"
                    class="btn-sm"
                    v-b-modal.modal-pdf
                    >pdf</b-button
                  >
                  <b-button
                    @click="showPDF(data.item.id)"
                    class="btn-sm"
                    variant="primary"
                    v-b-modal.modal-interview-form
                    >استمارة المقابلة</b-button
                  >

                  <b-button
                    v-can="'delete_volunteer_application'"
                    class="btn-sm ml-1"
                    variant="danger"
                    title="حذف"
                    @click="deleteItem(data.item.id)"
                    ><i class="bx bx-trash"></i
                  ></b-button>
                </div>
              </template>
            </b-table>
          </div>

          <!-- Footer Table -->
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItemsFiltered"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-start">
                <p>
                  عرض من {{ start }} الى {{ end }} من مجموع {{ totalItemsFiltered }}
                  <spam v-if="totalItemsFiltered != totalItems"
                    >(تمت تصفيته من إجمالي {{ totalItems }} إدخالاً)</spam
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
